import { createBrowserRouter, Navigate } from 'react-router-dom'
import { DemoLanding } from './auth/DemoLanding'
import { AuthGuard } from './auth/AuthGuard'
import { AppShell } from './layout/AppShell'
import { ProjectListPage } from './features/projects/ProjectListPage'
import { ProjectDetailLayout } from './features/projects/ProjectDetailPage'
import { ProjectDashboard } from './features/projects/ProjectDashboard'
import { ProjectMaterialsTab } from './features/materials/ProjectMaterialsTab'
import { MaterialCatalogPage } from './features/materials/MaterialCatalogPage'
import { ProjectMaterialRequestsPage } from './features/material-requests/MaterialRequestListPage'
import { MaterialRequestEditor } from './features/material-requests/MaterialRequestEditor'
import { MaterialReceiptListPage } from './features/material-receipts/MaterialReceiptListPage'
import { AttendancePage } from './features/attendance/AttendancePage'
import { DailyReportListPage } from './features/daily-reports/DailyReportListPage'
import { DailyReportEditor } from './features/daily-reports/DailyReportEditor'
import { VendorListPage } from './features/vendors/VendorListPage'
import { VendorDetailPage } from './features/vendor-billing/VendorDetailPage'
import { ClientPaymentsPage } from './features/client-payments/ClientPaymentsPage'
import { ExpensesPage } from './features/expenses/ExpensesPage'
import { AccountsLayout } from './features/accounts/AccountsLayout'
import { AccountsSummaryPage } from './features/accounts/AccountsSummaryPage'
import { IncomeDrillDownPage } from './features/accounts/IncomeDrillDownPage'
import { GstReportPage } from './features/accounts/GstReportPage'
import { LabourAgencyReportPage } from './features/accounts/LabourAgencyReportPage'
import { PhotoGalleryPage } from './features/photos/PhotoGalleryPage'
import {
  ManpowerReportPage,
  ReportsLayout,
  StockReportPage,
} from './features/reports/ReportsPage'

export const router = createBrowserRouter([
  { path: '/', element: <DemoLanding /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/projects', element: <ProjectListPage /> },
          {
            path: '/projects/:projectId',
            element: <ProjectDetailLayout />,
            children: [
              { index: true, element: <ProjectDashboard /> },
              {
                path: 'materials',
                element: <ProjectMaterialsTab />,
                children: [
                  { index: true, element: <ProjectMaterialRequestsPage /> },
                  { path: 'new', element: <MaterialRequestEditor /> },
                  { path: 'receipts', element: <MaterialReceiptListPage /> },
                ],
              },
              { path: 'attendance', element: <AttendancePage /> },
              {
                path: 'daily-reports',
                children: [
                  { index: true, element: <DailyReportListPage /> },
                  { path: 'new', element: <DailyReportEditor /> },
                ],
              },
              { path: 'bills', element: <Navigate to="../accounts" replace /> },
              { path: 'payments', element: <ClientPaymentsPage /> },
              { path: 'expenses', element: <ExpensesPage /> },
              { path: 'photos', element: <PhotoGalleryPage /> },
              {
                path: 'accounts',
                element: <AccountsLayout />,
                children: [
                  { index: true, element: <AccountsSummaryPage /> },
                  { path: 'income', element: <IncomeDrillDownPage /> },
                  { path: 'gst', element: <GstReportPage /> },
                  { path: 'labour', element: <LabourAgencyReportPage /> },
                ],
              },
            ],
          },
          { path: '/materials', element: <MaterialCatalogPage /> },
          { path: '/vendors', element: <VendorListPage /> },
          { path: '/vendors/:vendorId', element: <VendorDetailPage /> },
          {
            path: '/reports',
            element: <ReportsLayout />,
            children: [
              { index: true, element: <ManpowerReportPage /> },
              { path: 'stock', element: <StockReportPage /> },
            ],
          },
        ],
      },
    ],
  },
])
